<template>
  <div class="container mt-4">
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center py-5">
      <div class="spinner-border text-primary" role="status" aria-label="Loading"></div>
    </div>

    <div v-else class="d-flex flex-column">
      <h2 class="mb-5 mt-4">{{ title }}</h2>

      <div class="d-flex flex-column align-items-start">
        <div class="col-md-6">
          <label class="generalLabel">Pref. Channel:
          </label>

          <div>
            <select class="form-control" v-model="communicationChannel" :disabled="isPortalReadonly">
              <option value="Email & SMS">Email & SMS</option>
              <option value="Email">Email</option>
              <option value="SMS">SMS</option>
            </select>
          </div>
        </div>

        <div class="col-md-6 mt-2">
          <button style="width: 100%;" class="btn btn-primary" :disabled="isPortalReadonly" @click="updateCommunicationPreference">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import types from "./types";
import { mapState } from "vuex";
export default {
  name: 'CommunicationPreferences',
  computed: mapState({
    isPortalReadonly: (state) => state.portalStore.portalReadonly,
  }),
  data() {
    return {
      title: "Communication Preferences",
      isLoading: false,
      communicationChannel: 'Email & SMS',
    }
  },
  async mounted() {
    await this.getCommunicationPreference();
  },
  methods: {
    normalizeCommunicationChannel(value) {
      if (!value) return "Email & SMS";

      const normalizedValue = value.toString().trim().toLowerCase();
      if (
        normalizedValue == "sms and email" ||
        normalizedValue == "email and sms" ||
        normalizedValue == "email & sms" ||
        normalizedValue == "both"
      ) {
        return "Email & SMS";
      }

      if (normalizedValue == "email") return "Email";
      if (normalizedValue == "sms") return "SMS";

      return "Email & SMS";
    },
    async updateCommunicationPreference() {
      if (this.isPortalReadonly == true) return;

      this.isLoading = true;
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (userInfo && userInfo.Id) {
        const data = {
          CustomerId: userInfo.Id,
          PreferredCommunication: this.communicationChannel,
        };

        const [err, result] = await this.$store.dispatch(
          types.UPDATE_TAG_PREFERRED_COMMUNICATIONS,
          data
        );

        if (!err && result) {
          this.$swal("Success!", "Commms updated", "success")
        }
        this.isLoading = false;
      }
    },
    async getCommunicationPreference() {
      this.isLoading = true;
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (userInfo && userInfo.Id) {
        const data = {
          CustomerId: userInfo.Id,
        };

        const [err, result] = await this.$store.dispatch(
          types.GET_TAG_PREFERRED_COMMUNICATIONS,
          data
        );

        if (result && result.Data) {
          this.communicationChannel = this.normalizeCommunicationChannel(result.Data.PreferredCommunication);
        }

        this.isLoading = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>